import theme from '../../theme';
import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';

const COLOR_OUTLINED_GREY = theme.palette.grey.w200;

export const styledTextEllipsis = {
  width: '100%',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis'
}

export const BoxBorderGrey = styled(Box)(({ theme }) => ({
  padding: '8px',
  border: `1px solid ${COLOR_OUTLINED_GREY}`,
  borderRadius: '4px'
}))

export const BoxModalWrapper = styled(Box)(({ theme }) => ({
  padding: '16px 0 16px',
  backgroundColor: '#fff',
  borderRadius: '16px',
}))

export const BoxModalAlert = styled(Box)(({ theme }) => ({
  padding: '48px',
  backgroundColor: '#fff',
  borderRadius: '8px',
}))

export const BoxFlexStartStart = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-start'
}))

export const BoxFlexBetweenStart = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start'
}))

export const BoxFlexBetweenCenter = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}))

export const BoxFlexStartCenter = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center'
}))

export const BoxFlexCenterStart = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start'
}))

export const BoxFlexCenterCenter = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
})

export const BoxFlexColumnCenterCenter = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
})

export const ModalWrapperNormal = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  width: '96%',
  maxWidth: 1200,
  padding: '16px 0',
  backgroundColor: '#FFF',
  boxShadow: 24,
  borderRadius: '8px',
  transform: 'translate(-50%, -50%)',
}))

export const ModalWrapperSimple = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  padding: '32px 40px',
  backgroundColor: '#FFF',
  boxShadow: 24,
  borderRadius: '8px',
  transform: 'translate(-50%, -50%)',
}))

export const ModalContentCenterCenterSmall = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 400,
  maxWidth: '60%',
  padding: '40px',
  backgroundColor: '#fff',
  boxShadow: 24,
  borderRadius: '8px'
}))

export const ModalPapper = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  minWidth: '300px',
  maxWidth: '800px',
  textAlign: 'center',
  backgroundColor: '#FFF',
  borderRadius: '16px',
  boxShadow: 24,
  transform: 'translate(-50%, -50%)',

  '&:focus-visible': {
    outline: 'none'
  }
})

export const BoxTable = styled(Box)(({ theme }) => ({
  display: 'table',
  width: '100%'
}))

export const BoxTableRow = styled(Box)(({ theme }) => ({
  display: 'table-row'
}))

export const BoxTableCell = styled(Box)(({ theme }) => ({
  ...theme.typography.body2,
  display: 'table-cell',
  padding: '4px 16px 4px 0',

}))